import React, { useEffect, useState } from 'react';
import {
	Wrapper,
	TitleWrapper,
	Title,
	ActionWrapper,
	ToggleSwitch,
	ContentWrapper,
} from './TimelineContent.styles';
import TimelineOne from './TimelineOne';
import TimelineTwo from './TimelineTwo';
import { getTimelineSettings } from 'utils/apiRequests';
import { keyToSaveAndRetriveSKUSetting } from '../../utils';
import { Loader } from 'SpeedToMarket/Tabs/CategoryWidget/utils';

const TimelineContent = props => {
	const { sku } = props.skuDetails;
	const [isDrillDown, setIsDrillDown] = useState(false);
	const [groupByKeys, setGroupByKeys] = useState([]);
	const [isKeysFetching, setIsKeysFetching] = useState(true);

	useEffect(() => {
		const fetchKeys = async () => {
			const bodyParam = {
				key: keyToSaveAndRetriveSKUSetting,
			};
			const { succeeded, data } = await getTimelineSettings(bodyParam);
			if (succeeded) {
				const timelineKeys = data.filter(
					x => x.key === keyToSaveAndRetriveSKUSetting
				);
				if (timelineKeys.length > 0) {
					const keysPresent = JSON.parse(timelineKeys[0].value).map(x => {
						return { label: x.label, value: x.selected };
					});
					setGroupByKeys(keysPresent);
				}
				setIsKeysFetching(false);
			} else {
				setIsKeysFetching(false);
			}
		};
		fetchKeys();
	}, []);

	return (
		<>
			{isKeysFetching ? (
				<Loader />
			) : (
				<Wrapper>
					<TitleWrapper>
						<Title>Timeline Analysis for {sku}.</Title>
						<ActionWrapper>
							<div>Apply Keys:</div>
							<div>
								<ToggleSwitch
									defaultChecked={isDrillDown}
									onChange={() => setIsDrillDown(!isDrillDown)}
								/>
							</div>
						</ActionWrapper>
					</TitleWrapper>
					<ContentWrapper>
						{isDrillDown ? (
							<TimelineTwo {...props} groupByKeys={groupByKeys} />
						) : (
							<TimelineOne {...props} />
						)}
					</ContentWrapper>
				</Wrapper>
			)}
		</>
	);
};

export default TimelineContent;
